import { render, staticRenderFns } from "./ParasiteDataMst.vue?vue&type=template&id=6ac285f3"
import script from "./ParasiteDataMst.vue?vue&type=script&lang=js"
export * from "./ParasiteDataMst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports